import React from 'react';
import './accounting-integration-in-progress.scss';
import { Button, ButtonColor, ButtonVariant } from '@ampol/design-system';

/**
 * Accounting Integration In Progress
 * @returns JSX Element
 */
const AccountingIntegrationInProgress = ({ onDoneClick, organisationName }) => {
  return <>
    <div>
      Login process for {organisationName} has been opened in a new browser tab. Please click &apos;Done&apos; once login is completed.
    </div>
    <Button
      color={ButtonColor.Blue}
      label="Done"
      onClick={onDoneClick}
      variant={ButtonVariant.Primary}
    />
  </>;
};

export default AccountingIntegrationInProgress;
